import React, { useState } from 'react'
import { Star, X } from 'lucide-react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@components/ui/dialog'
import { Button } from '@components/ui/button'

const RatingModal = ({ onClose, onRating, withoutModal }) => {
  const [hoveredRating, setHoveredRating] = useState(0)

  const Content = () => (
    <div className="space-y-4">
      {!withoutModal && (
        <DialogHeader>
          <DialogTitle className="text-center">Rate Your Experience</DialogTitle>
        </DialogHeader>
      )}
      {withoutModal && <h2 className="text-center font-semibold text-lg">Rate Your Experience</h2>}
      <div className="flex justify-center mb-4 gap-2">
        {[1, 2, 3, 4, 5].map((item) => (
          <Button
            key={`rate-${item}`}
            variant="ghost"
            size="icon"
            className={`hover:bg-transparent focus:ring-0 ${item <= hoveredRating ? 'text-yellow-500' : 'text-gray-400'}`}
            onMouseEnter={() => setHoveredRating(item)}
            onMouseLeave={() => setHoveredRating(0)}
            onClick={() => {
              onRating(item)
            }}
          >
            <Star className="h-8 w-8" fill={item <= hoveredRating ? 'currentColor' : 'none'} />
          </Button>
        ))}
      </div>
      <div className="text-center text-sm text-muted-foreground">
        {hoveredRating === 1 && 'Poor'}
        {hoveredRating === 2 && 'Fair'}
        {hoveredRating === 3 && 'Good'}
        {hoveredRating === 4 && 'Very Good'}
        {hoveredRating === 5 && 'Excellent'}
      </div>
    </div>
  )

  if (withoutModal) return <Content />

  return (
    <Dialog open onOpenChange={() => onClose()}>
      <DialogContent className="sm:max-w-[400px]">
        <Button variant="ghost" size="icon" className="absolute right-2 top-2" onClick={onClose}>
          <span className="sr-only">Close</span>
          <X className="h-4 w-4" />
        </Button>
        <Content />
      </DialogContent>
    </Dialog>
  )
}

export default RatingModal
